import React from 'react';
import Facilities from '../components/Facilities';

const FacilitiesPage = () => {
  return (
    <main className="pt-20">
      <Facilities />
    </main>
  );
};

export default FacilitiesPage; 